import {EnrollmentRoutingModule} from './enrollment-routing/enrollment-routing.module';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LayoutModule} from '@angular/cdk/layout';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ENROLLMENT_MATERIAL_IMPORT} from './material-dependencies';
import {ClientDetailsModule} from 'r2-client-details-module';
import {AdvisorModule} from 'r2-advisor-module';
import {FinalizeModule} from 'r2-finalize';
import {DeclarationModule} from 'declaration';
import {PaymentModule} from 'r2-payment';
import {BeneficiaryModule} from 'r2-beneficiary-module';
import {BugReporterModule} from 'r2-bug-reporter';
import {NgHttpLoaderModule} from 'ng-http-loader';
import {AppComponent} from './app.component';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material';
import {CookieService} from 'ngx-cookie-service';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {HttpConfigInterceptor} from './http-header-intercepter/HttpConfigInterceptor';
import {CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {JWT_OPTIONS, JwtHelperService, JwtModule} from '@auth0/angular-jwt';
import {EnrollmentConfirmComponent} from './enrollment-confirm/enrollment-confirm.component';
import {ErrorHandlerModule} from 'r2-error-handler-module';


const DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
const MODULE_DEPENDENCIES: any = [
  EnrollmentRoutingModule,
  BrowserModule,
  BrowserAnimationsModule,
  LayoutModule,
  HttpClientModule,
  FormsModule,
  ReactiveFormsModule,
  NgHttpLoaderModule,
  JwtModule,
  ErrorHandlerModule
];

const SUB_MODULE_DEPENDENCIES: any = [
  ClientDetailsModule,
  AdvisorModule, FinalizeModule, DeclarationModule,
  PaymentModule, BeneficiaryModule, BugReporterModule
];

const APP_DEPENDENCIES_IMPORT: any = [MODULE_DEPENDENCIES, ENROLLMENT_MATERIAL_IMPORT, SUB_MODULE_DEPENDENCIES];

const DECLARATIONS: any = [AppComponent, EnrollmentConfirmComponent];

const PROVIDERS: any = [CookieService,
  {provide: JWT_OPTIONS, useValue: JWT_OPTIONS},
  JwtHelperService,
  {provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true},
  {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
  AppComponent,
  {provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS}
];

const BOOTSTRAP: any = [AppComponent];
const SCHEMAS: any = [CUSTOM_ELEMENTS_SCHEMA];
const ENTRY_COMPONENTS: any = [EnrollmentConfirmComponent];

export const NG_MODULE_DECLARATION: any = {
  declarations: DECLARATIONS,
  imports: APP_DEPENDENCIES_IMPORT,
  providers: PROVIDERS,
  bootstrap: BOOTSTRAP,
  entryComponents: ENTRY_COMPONENTS,
  schemas: SCHEMAS
};
